import React, { useEffect, useRef, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { JVDropdown } from '../../shared/JVDropdown';
import { Fetch } from '../../shared/Fetch';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
import { OverlayPanel } from 'primereact/overlaypanel';
import { EmptyAssignmentMastFilter, IAssignmentMastFilter } from '../AssignmentMast/Filter';

interface IProps {
    singleData: IAssignment,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export interface IAssignment {
    id?: number;
    department?: string;
    target?: number;
    assignment_Name?: string
    assignment_Descriptions?: string;
    achieved?: number;
    acquire?: number;
    start_Date?: Date;
    end_Date?: Date;
    is_Approved?: boolean,
    reject_Reason?: string,
    assignment?: Array<{ id: number, question_Id: number; assignment_Descriptions: string; assignment_Name: string; target: number; start_Date: Date; end_Date: Date }>;
    verify_Achieved?: boolean,
    rating?:number,
    login_Id?:number

}
export const emptyAssignment: IAssignment = {
    department: '',
    target: 0,
    assignment_Descriptions: '',
    achieved: 0,
    acquire: 0,
    assignment: [],
};
const schema = yup.object().shape({
    department: yup.string().required('Department required'),
});



const roles = [{ name: "Recruiter" }, { name: "Sales" }];
export const Form = (props: IProps) => {    
    const [assignment, setAssignment] = useState<IAssignment[]>([]);
    const [editableAssignmentId, setEditableAssignmentId] = useState<number | null>(null);
    const overlayPanelRef = useRef<OverlayPanel>(null);
    const [assignmentDescription, setAssignmentDescription] = useState<IAssignment>();
    const[filters, setFilters]= useState<IAssignmentMastFilter>(EmptyAssignmentMastFilter)


    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<IAssignment>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData || emptyAssignment,
        shouldFocusError: false
    });


    useEffect(() => {
        reset(props.singleData)
        if (props.singleData?.assignment) {
            const updatedAssignments = props.singleData?.assignment.map((item) => ({
                id: item.question_Id,
                assignment_Descriptions: item.assignment_Descriptions,
                assignment_Name: item.assignment_Name,
                target: item.target,
                start_Date: new Date(item.start_Date),
                end_Date: new Date(item.end_Date),
            }))
            setAssignment(updatedAssignments);
            setFilters(EmptyAssignmentMastFilter);
        } else {
            setAssignment([]);
        }
    }, [props.singleData]);


    const onSubmit = async (data: IAssignment) => {
        const updatedAssignments = assignment.filter((item) => {
            const original = props.singleData.assignment?.find((orig: IAssignment) => orig.id === item.id);
            const isChanged =
                item.start_Date !== original?.start_Date ||
                item.end_Date !== original?.end_Date ||
                item.target !== original?.target;
            return isChanged;
        });

        // console.log(updatedAssignments);

        const invalidAssignments = updatedAssignments.filter(
            (item) => !item.start_Date || !item.end_Date || !item.target
        );

        if (invalidAssignments.length > 0) {
            props.toast.current.show({ severity: "error", detail: "Please fill in all required fields (Start Date, End Date, Target) for all assignments.", life: 3000, });
            return;
        }

        const invalidDateRange = updatedAssignments.find(
            (item) => item.end_Date && item.start_Date && item.end_Date < item.start_Date
        );

        if (invalidDateRange) {
            props.toast.current.show({ severity: "error", detail: "End Date cannot be earlier than Start Date.", life: 3000, });
            return;
        }

        const formData = {
            ...data,
            assignment: updatedAssignments,
        };

        // console.log(formData);
        if (formData.assignment.length === 0) {
            props.toast.current.show({ severity: "error", detail: "No changes made to assignments.", life: 3000, });
            return;
        }
        const method = props.singleData.id ? "PUT" : "POST";
        const response = await Fetch("Assignment_Mast/assignments", method, formData, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: "success", detail: "Saved Successfully", life: 3000 });
            onHide();
            props.setReload(!props.reload);
        }
    };

    const selectedRole = watch("department");

    const loadAssignment = async (name: string) => {
        const response = await Fetch('Assignment_Mast', 'GET', null, `roles_Name=${name}&filter=${JSON.stringify(filters)}`, props.toast);
        if (response) {
            const data = await response.json();
            setAssignment(data);
        }
        if (props.singleData?.assignment?.length) {
            if (props?.singleData?.assignment?.length > 0) {
                let updatedAssignments = assignment.map((item: any) => {
                    let AssignmentToBeUpdated = assignment.filter((f: any) => f.id === item.id);
                    item.target = AssignmentToBeUpdated[0]?.target || 0;
                    item.start_Date = AssignmentToBeUpdated[0].start_Date;
                    item.end_Date = AssignmentToBeUpdated[0].end_Date;
                    item.assignment_Name = AssignmentToBeUpdated[0].assignment_Name
                    return item;
                });
                setAssignment(updatedAssignments);
            }
        }
        // console.log(assignment);

    };
    useEffect(() => {
        if (selectedRole) {
            loadAssignment(selectedRole);
        }
    }, [selectedRole]);

    const onEditButtonClick = (rowData: IAssignment) => {
        // console.log(rowData);
        setEditableAssignmentId(rowData.id || null);
    };

    const renderEditButton = (rowData: IAssignment) => {
        const buttonLabel = props.singleData.assignment?.length ? "Edit" : editableAssignmentId === rowData.id ? "Selected..." : "Select";
        return (
            <Button type='button' label={buttonLabel} className={`p-button-${editableAssignmentId === rowData.id ? "warning" : "info"}`} onClick={() => onEditButtonClick(rowData)} disabled={false} />
        )
    };


    const renderTargetEditor = (rowData: IAssignment) => (
        <InputText value={rowData.target || ""} onChange={(e) => onTargetChange(e, rowData)} placeholder="Target" disabled={editableAssignmentId !== rowData.id} />
    );

    const onTargetChange = (e: any, rowData: IAssignment) => {
        const updatedAssignments = assignment.map((item: any) =>
            item.id === rowData.id ? { ...item, target: e.target.value } : item
        );
        setAssignment(updatedAssignments);
    };

    const today = new Date();

    const renderStartDateEditor = (rowData: IAssignment) => (
        <Calendar minDate={today} value={rowData.start_Date || undefined} onChange={(e: any) => onStartDateChange(e.target.value, rowData)} dateFormat="yy-mm-dd" placeholder="Start Date" disabled={editableAssignmentId !== rowData.id} showIcon />
    );

    const onStartDateChange = (date: Date, rowData: IAssignment) => {
        const updatedAssignments = assignment.map((item) =>
            item.id === rowData.id ? { ...item, start_Date: date } : item
        );
        setAssignment(updatedAssignments);
    };

    const renderEndDateEditor = (rowData: IAssignment) => (
        <Calendar minDate={rowData.start_Date || today} value={rowData.end_Date || undefined} onChange={(e: any) => onEndDateChange(e.target.value, rowData)} dateFormat="yy-mm-dd" placeholder="End Date" disabled={editableAssignmentId !== rowData.id} showIcon />
    );

    const onEndDateChange = (date: Date, rowData: IAssignment) => {
        const updatedAssignments = assignment.map((item) =>
            item.id === rowData.id ? { ...item, end_Date: date } : item
        );
        setAssignment(updatedAssignments);
    };

    const onHide = () => {
        props.hideDialog();
        props.setReload(!props.reload);
        reset(emptyAssignment);
        setAssignment([]);
    };
    const isApproved = props.singleData?.is_Approved === true;


    const actionBodyTemplate = (rowData: any) => {
        return (
            <span className="p-button p-button-text" onMouseEnter={(e) => showOverlay(e, rowData)}>
                {rowData.assignment_Name}
            </span>
        );
    };

    const showOverlay = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>, rowData: any) => {
        setAssignmentDescription(rowData);
        if (overlayPanelRef.current) {
            overlayPanelRef.current.toggle(event); // Show the OverlayPanel
        }
    };

    return (
        <Dialog visible={props.open} style={{ width: '65vw' }} header="Add/Edit Assignment" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdown required column={2} label="Department" name="department" disabled={props.singleData?.department ? true : false} control={control} options={roles} optionLabel="name" optionValue="name" placeholder="--Select Department --" />
                <div style={{ marginTop: '10px', marginBottom: '20px', marginLeft: "12px", width: '65vw' }}>
                    <DataTable
                        style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", display: `${assignment?.length > 0 ? "block" : "none"}` }}
                        size="small"
                        dataKey="id"
                        resizableColumns
                        showGridlines
                        emptyMessage="No Assignment found."
                        columnResizeMode="expand"
                        value={assignment}
                        editMode="cell"
                    >
                        <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                        <Column field="assignment_Name" header="Assignment Name" body={actionBodyTemplate} />
                        <Column field='start_Date' header="Start Date" body={renderStartDateEditor} />
                        <Column field='end_Date' header="End Date" body={renderEndDateEditor} />
                        <Column field="target" header="Target" body={renderTargetEditor} />
                        <Column header="Action" body={renderEditButton} />
                    </DataTable>
                    <OverlayPanel ref={overlayPanelRef}>
                        {assignmentDescription && (
                            <div>
                                <p><strong>Description:</strong> {assignmentDescription?.assignment_Descriptions}</p>
                            </div>
                        )}
                    </OverlayPanel>
                </div>
                <div className="col-12 md:col-12 flex gap-4">
                    <Button className="field col md:col" label="SAVE" type="submit" disabled={isApproved}></Button>
                    <Button className="field col md:col p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
};
